const ALIASES: Record<string, string> = {
  mercedes: 'MB',
  mercedesbenz: 'MB',
  mb: 'MB',
  vw: 'Volkswagen',
  chevy: 'Chevrolet',
  bmw: 'BMW',
  gmc: 'GMC',
  byd: 'BYD',
  ram: 'RAM',
  mclaren: 'McLaren',
  landrover: 'Landrover',
  rolls: 'Rolls Royce',
  rollsroyce: 'Rolls Royce',
  mini: 'Mini',
  minicooper: 'Mini',
};

export function resolveVehicleBrandIcon(
  make: string | null | undefined,
): string | null {
  const trimmed = make?.trim();
  if (!trimmed) {
    return null;
  }
  const key = trimmed.toLowerCase().replace(/[^a-z0-9]/g, '');
  const brand =
    ALIASES[key] ??
    trimmed.toLowerCase().replace(/(^|[\s-])([a-z])/g, (_m, sep, ch) => {
      return sep + ch.toUpperCase();
    });
  return `/assets/vehicle-brands/${encodeURIComponent(`${brand} Icon.svg`)}`;
}
